import React from 'react';
import Icon from './Icon';
import T from 'i18n-react';

import classNames from 'classnames';

export default class ValidatorBoard extends React.Component{

  constructor(props){
    super(props);
    this.state={
      value: null,
      minCharacters: this.props.minchars,
      maxCharacters: this.props.maxchars,
      requireCapitals: this.props.reqcapitals,
      requireNumbers: this.props.reqnumbers,
        requireSplChars: this.props.reqsplchars,
      name: this.props.name,
      hint:this.props.hint,
      errorMessage:this.props.errorMessage,
        instaCheckMsg:this.props.instaCheckMsg,
        instaError:this.props.instaError,
      errorVisible:this.props.errorVisible
    }
  }
  componentWillReceiveProps(nextProps) {

  if(nextProps.instaError){
    this.setState({instaError:true,instaCheckMsg:nextProps.instaCheckMsg})
  }else{
      this.setState({instaError:false,instaCheckMsg:nextProps.instaCheckMsg})
  }
  if(nextProps.errorVisible){
    this.setState({errorVisible:true})
  }else{
    this.setState({errorVisible:false})
  }
  }
  render(){
    var validatorClass = classNames({
      'password_validator':   true,
      'visible':              this.props.visible,
      'invisible':            !this.props.visible
    });






    return (
      <div className={validatorClass}>
        <div className="validator_container">

        <h4 className="validator_title invalid">
          {this.props.name} RULES
        </h4>

          <ul className="rules_list">
          {this.state.hint!=false?  <li className={classNames({'valid':true})}>
              <i className="icon_hint"> <Icon type="hint"/> </i>
              <i className="icon_invalid"> <Icon type="circle_error"/> </i>
              <span className="error_message"> {this.state.hint}</span>
            </li>:null}
          {this.state.minCharacters!="0"?  <li className={classNames({'valid': this.props.validData.minChars})}>
              <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
              <i className="icon_invalid"> <Icon type="circle_error"/> </i>
              <span className="error_message">{this.state.minCharacters} characters minimum</span>
            </li>:null}
            {this.state.maxCharacters!="0"?  <li className={classNames({'valid': this.props.validData.maxChars})}>
                <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                <span className="error_message">{this.state.maxCharacters} characters maximum</span>
              </li>:null}

        {this.state.requireCapitals=="R"?<li className={classNames({'valid': this.props.validData.capitalLetters})}>
              <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
              <i className="icon_invalid"> <Icon type="circle_error"/> </i>
              <span className="error_message">Contains at least 1 capital letter </span>
            </li>:null}
            {this.state.requireCapitals=="NRN"?<li className={classNames({'valid': this.props.validData.capitalLetters})}>
                  <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                  <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                  <span className="error_message">Capital letters not allowed</span>
                </li>:null}

          {this.state.requireNumbers=="R" ?  <li className={classNames({'valid': this.props.validData.numbers})}>
              <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
              <i className="icon_invalid"> <Icon type="circle_error"/> </i>
              <span className="error_message">Contains at least 1 number</span>
            </li>:null}
            {this.state.requireNumbers=="NRN" ?  <li className={classNames({'valid': this.props.validData.numbers})}>
                <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                <span className="error_message">Numbers are not allowed</span>
              </li>:null}
            {this.state.requireSplChars=="NRN"?  <li className={classNames({'valid': this.props.validData.splchars})}>
                <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                <span className="error_message">Special characters not allowed</span>
              </li>:null}
              {this.state.requireSplChars=="R"?  <li className={classNames({'valid': this.props.validData.splchars})}>
                  <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                  <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                  <span className="error_message">Contains at least 1 special character</span>
                </li>:null}
                {this.state.errorVisible==true?  <li className={classNames({'valid':false})}>
                    <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                    <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                    <span className="error_message">{this.state.errorMessage}</span>
                  </li>:null}
                  {this.state.instaError==true?  <li className={classNames({'valid':false})}>
                      <i className="icon_valid"> <Icon type="circle_tick_filled"/> </i>
                      <i className="icon_invalid"> <Icon type="circle_error"/> </i>
                      <span className="error_message">  {T.translate(`error_Codes.${this.state.instaCheckMsg}`)}</span>
                    </li>:null}

          </ul>
        </div>
      </div>
    )
  }
}
